module.exports = __webpack_public_path__ + "img/4.eaa1e4cc.jpg";